import script from "./ModalCover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalCover.vue?vue&type=script&setup=true&lang=ts"

import "./ModalCover.vue?vue&type=style&index=0&id=847d0fc8&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-847d0fc8"]])

export default __exports__